export const PRIZE = {
  'United States of America': 1000,
  India: 100,
};
